import React, {Component} from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import {afterCheckoutConfirmation} from './../actions/navOptions';

const SpotConfirmedMessage = ({ afterCheckoutConfirmation }) => (
  <div className="map-page map-page__message">
    <div className="map-page-content" id="message-confirmed">
      <div className="icon-check" />
      <h3>Your spot is confirmed!</h3>
      <a onClick={afterCheckoutConfirmation} className="btn btn-primary btn-lg">OK!</a>
    </div>
  </div>
);

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators({afterCheckoutConfirmation}, dispatch);
};

export default connect(undefined, mapDispatchToProps)(SpotConfirmedMessage);



// WEBPACK FOOTER //
// ./src/containers/SpotConfirmedMessage.js